export default {
  online: '在线',
  offline: '离线',
  deviceSn: '设备SN：',
  deviceType: '设备类型：',
  viewDetail: '查看详情',
  edit: '修改',
  editTitle: '修改机器人信息',
  cancel: '取消',
  confirm: '确认',
  fieldId: 'ID',
  fieldSn: '设备SN',
  fieldStatus: '状态',
  fieldAlias: '别名',
  fieldAliasEn: '英文别名',
  fieldDeviceType: '设备类型',
  fieldRobotType: '机器人类型',
  placeholderSn: '请输入设备SN',
  placeholderStatus: '请输入状态',
  placeholderAlias: '请输入别名',
  placeholderAliasEn: '请输入英文别名',
  placeholderDeviceType: '请输入设备类型',
  placeholderRobotType: '请输入机器人类型',
  ruleSn: '请输入设备SN',
  ruleStatus: '请输入状态',
  ruleAlias: '请输入别名',
  ruleAliasEn: '请输入英文别名',
  ruleDeviceType: '请输入设备类型',
  ruleRobotType: '请输入机器人类型',
  successUpdate: '修改成功',
  failUpdate: '修改失败',
  empty: '暂无设备数据',
  unsupportedType: '该设备类型暂不支持查看详情',
}
